import LOGO from "../images/joeles.png";

export const Team__Joeles = {
  name: "Joeles",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#ff7781",
  teamJerseyColor: "#0E293D",

  // Stats
  gamesWon: 3,
  gamesLost: 0,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 31 + 19 + 20,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 32 + 33 + 49,
    },
  ],
};
